import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

export const gsapAnimations = () => {

    gsap.registerPlugin(ScrollTrigger);

    const numbers = document.querySelectorAll(".number");

    if (numbers.length > 0) {

        // Find integers, alpha characters, and special characters in numbers and wrap them in spans
        numbers.forEach(numberElement => {
            const text = numberElement.textContent;
            // Replace integers, alpha, and special characters with respective spans
            const newHTML = text.replace(/(\d+)|([a-zA-Z]+)|([^a-zA-Z\d]+)/g, (match, integer, alpha, special) => {
                if (integer) {
                    return `<span class="number-integer" data-number="${integer}">${integer}</span>`;
                } else if (alpha) {
                    return `<span class="number-alpha">${alpha}</span>`;
                } else if (special) {
                    return `<span class="number-special">${special}</span>`;
                }
                return match;
            });
            numberElement.innerHTML = newHTML;
        });

        // Animate only when each `.number` element gains the 'over' class
        numbers.forEach(numberEl => {
            let hasPlayed = false;

            const playIfOver = () => {

                if (!hasPlayed && numberEl.classList.contains("over")) {
                    hasPlayed = true;
                    const scopedIntegers = numberEl.querySelectorAll(".number-integer");
                    if (scopedIntegers.length > 0) {
                        gsap.from(scopedIntegers, {
                            textContent: 0,
                            duration: 3,
                            ease: "power1.in",
                            snap: { textContent: 1 },
                            stagger: {
                                onUpdate: function () {
                                    this.targets()[0].innerHTML = numberWithCommas(Math.ceil(this.targets()[0].textContent));
                                },
                            }


                        });

                        function numberWithCommas(x) {
                            return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
                        }
                    }
                }
            };

            // In case the class is already present on load
            playIfOver();

            // Observe class changes to detect when 'over' is added
            const observer = new MutationObserver(mutations => {
                for (const mutation of mutations) {
                    if (mutation.type === "attributes" && mutation.attributeName === "class") {
                        playIfOver();
                    }
                }
            });

            observer.observe(numberEl, { attributes: true });
        });
    }

    // Utility: wrap a .number element's content if not already wrapped
    const wrapNumberIfNeeded = (numberElement) => {
        if (!numberElement.querySelector('.number-integer')) {
            const text = numberElement.textContent;
            const newHTML = text.replace(/(\d+)|([a-zA-Z]+)|([^a-zA-Z\d]+)/g, (match, integer, alpha, special) => {
                if (integer) {
                    return `<span class="number-integer" data-number="${integer}">${integer}</span>`;
                } else if (alpha) {
                    return `<span class="number-alpha">${alpha}</span>`;
                } else if (special) {
                    return `<span class="number-special">${special}</span>`;
                }
                return match;
            });
            numberElement.innerHTML = newHTML;
        }
    };

    // When a Swiper slide becomes active, trigger count-up for any `.number` inside it
    const activateNumbersInSlide = (slide) => {
        const slideNumbers = slide.querySelectorAll('.number');
        if (slideNumbers.length > 0) {
            slideNumbers.forEach(numberEl => {
                // Ensure markup prepared for counting
                wrapNumberIfNeeded(numberEl);

                const scopedIntegers = numberEl.querySelectorAll('.number-integer');
                if (scopedIntegers.length === 0) return;

                // Reset to 0 before recount so it animates every time slide becomes active
                scopedIntegers.forEach(span => {
                    span.textContent = 0;
                });

                // Animate up to their data-number values
                gsap.to(scopedIntegers, {
                    textContent: (i, el) => {
                        const target = parseInt(el.getAttribute('data-number'), 10);
                        return isNaN(target) ? 0 : target;
                    },
                    duration: 3,
                    ease: "power1.in",
                    snap: { textContent: 1 }
                });
            });
        }
    };

    // Handle currently active slides on load
    const activeSlides = document.querySelectorAll('.swiper-slide.swiper-slide-active');
    if (activeSlides.length > 0) {
        activeSlides.forEach(activateNumbersInSlide);
    }

    // Observe class changes to detect when slides become active
    if (window.MutationObserver) {
        const slideClassObserver = new MutationObserver(mutations => {
            for (const mutation of mutations) {
                if (mutation.type === 'attributes' && mutation.attributeName === 'class') {
                    const target = mutation.target;
                    if (target && target.classList && target.classList.contains('swiper-slide')) {
                        if (target.classList.contains('swiper-slide-active')) {
                            activateNumbersInSlide(target);
                        }
                    }
                }
            }
        });
        slideClassObserver.observe(document.body, { attributes: true, subtree: true, attributeFilter: ['class'] });
    }

}